export enum UndergroundWireIssueQuestionValue {
	ExposedWire = 'Exposed',
}
